import {connect} from "react-redux";
import {RootState, ThunkDispatch} from "../types";
import {userIsAllowed} from "../utils/commons";
import {doCreateArchetype, doCreateCallback, doDeleteArchetype, doDeleteCallback, doGetArchetypes, doGetCallbacks} from "../actions/thunks/users";
import {ArchetypesCallbacks, DispatchProps, InnerProps, StateProps} from "../components/ArchetypesCallbacks";

function mapStateToProps({user}: RootState): StateProps {
    return {
        callbacks: user.callbacks,
        archetypes: user.archetypes,
        svixAppPortalUrl: user.user?.svixAppPortalUrl,
        isAllowed: userIsAllowed(user.credits, "timestamp_api"),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGetCallbacks: (q) => dispatch(doGetCallbacks(q)),
        onCreateCallback: (call, q) => dispatch(doCreateCallback(call, q)),
        onGetArchetypes: (q) => dispatch(doGetArchetypes(q)),
        onCreateArchetype: (arch, q) => dispatch(doCreateArchetype(arch, q)),
        onDeleteCallback: (id, q) => dispatch(doDeleteCallback(id, q)),
        onDeleteArchetype: (id, q) => dispatch(doDeleteArchetype(id, q))
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(ArchetypesCallbacks);
